/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros
Descripcion:        Encapsular bloque input y label
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
--------------------------------------------------------------------------------------------------------------
*/
import React from 'react';

// propiedades
interface InputLayoutProps {
    label: string,              // texto de label
    className?: string,         // clases adicionales
    children: React.ReactNode,  // contenido
};

// componente
const InputLayout = ({ label, className = '', children }:InputLayoutProps) => {
    return (
        <div className={`form-group ${className}`}>
            <label>{label}</label>
            {children}
        </div>
    );
};

export default InputLayout;